import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import CardSlider from "./CardSlider";

const Partners = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [filter, setFilter] = useState("all");
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const partners = t("partners.list", { returnObjects: true });
  const countries = [...new Set(partners.map((partner) => partner.country))];

  const filteredPartners =
    filter === "all"
      ? partners
      : partners.filter((partner) => partner.country === filter);

  return (
    <section
      ref={sectionRef}
      id="partners"
      className="py-20  bg-white relative overflow-hidden"
    >
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-emerald-50/50 via-transparent to-teal-50/50"></div>
        <div className="absolute top-20 right-20 w-64 h-64 bg-gradient-to-r from-emerald-200/20 to-teal-200/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-80 h-80 bg-gradient-to-r from-cyan-200/20 to-blue-200/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        {/* Section header */}
        <div
          className={`text-center mb-16 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t("partners.title")}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-500 to-teal-500 mx-auto rounded-full mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Meet our amazing partners working together to create positive change
          </p>
        </div>

        {/* Partners Card Slider */}
        <div
          className={`transition-all duration-1000 delay-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <CardSlider
            cards={filteredPartners.map((partner) => ({
              id: partner.name,
              title: partner.name,
              description: partner.bio,
              image: partner.logo,
              badge: partner.country,
              country: partner.country,
              category: "Partner",
              link: partner.website,
            }))}
            autoplayInterval={4000}
            showArrows={true}
            showDots={true}
            className="mb-8"
          />
        </div>

        {/* Stats section */}
        {/* <div className={`mt-16 text-center transition-all duration-1000 delay-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="bg-gradient-to-r from-emerald-500 to-teal-500 rounded-3xl p-8 md:p-12 text-white">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold mb-2">{partners.length}</div>
                <div className="text-emerald-100">Total Partners</div>
              </div>
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold mb-2">{countries.length}</div>
                <div className="text-emerald-100">Countries</div>
              </div>
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold mb-2">100%</div>
                <div className="text-emerald-100">Dedicated</div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Partners;
